import { RootState } from "@/store/store";
import { resourceDetailsOptionsSelector } from "@/store/resource-details/selectors/options/resourceDetailsOptionsSelector";

export const resourceDetailsCoverageDataPointSelector = (state: RootState) => {
  const options = resourceDetailsOptionsSelector(state);

  return options.coverageRelated.data_point;
};
